import { TenantRow, TenantContextResult } from "@/lib/types";
import { TenantManagerShared } from "./TenantManager.shared";
import { DatabaseManager } from "@/lib/database/DatabaseManager.client";
import { SupabaseClient } from "@supabase/supabase-js";
import { ITenantManager } from "./ITenantManager";

export class TenantManager implements ITenantManager {
  private client: SupabaseClient;

  constructor() {
    this.client = DatabaseManager.createBrowserClient();
  }

  extractTenantSlug(host: string): string | null {
    return TenantManagerShared.extractTenantSlug(host);
  }

  canInviteMembers(tenant: TenantRow, userEmail: string | null): boolean {
    return TenantManagerShared.canInviteMembers(tenant, userEmail);
  }

  async loadTenantContext(host: string): Promise<TenantContextResult> {
    // Client-side stub - this should not be called on the client
    throw new Error("loadTenantContext is not available on the client side");
  }

  async getTenantLimits(tenantId: string): Promise<{
    file_upload_limit_mb: number | null;
    storage_limit_gb: number | null;
    member_limit: number | null;
    allow_bulk_invites: boolean | null;
    allow_multiple_admins: boolean | null;
    allow_audit_logs: boolean | null;
  }> {
    // Client-side stub - this should not be called on the client
    throw new Error("getTenantLimits is not available on the client side");
  }

  async checkFileSizeLimit(
    tenantId: string,
    fileSizeBytes: number
  ): Promise<{ allowed: boolean; limit?: number; current?: number }> {
    // Client-side stub - this should not be called on the client
    throw new Error("checkFileSizeLimit is not available on the client side");
  }

  async checkStorageLimit(
    tenantId: string,
    additionalSizeBytes?: number
  ): Promise<{
    allowed: boolean;
    limit?: number;
    current?: number;
    additional?: number;
  }> {
    // Client-side stub - this should not be called on the client
    throw new Error("checkStorageLimit is not available on the client side");
  }

  async canHaveMultipleAdmins(tenantId: string): Promise<boolean> {
    // Client-side stub - this should not be called on the client
    throw new Error(
      "canHaveMultipleAdmins is not available on the client side"
    );
  }

  async canUseBulkInvites(tenantId: string): Promise<boolean> {
    // Client-side stub - this should not be called on the client
    throw new Error("canUseBulkInvites is not available on the client side");
  }

  async hasAuditLogs(tenantId: string): Promise<boolean> {
    // Client-side stub - this should not be called on the client
    throw new Error("hasAuditLogs is not available on the client side");
  }

  async getMemberLimit(tenantId: string): Promise<number | null> {
    // Client-side stub - this should not be called on the client
    throw new Error("getMemberLimit is not available on the client side");
  }

  async updateTenant(
    tenantId: string,
    params: { name: string; description?: string; logoUrl?: string | null; heroImageUrl?: string | null; timezone?: string | null }
  ): Promise<boolean> {
    // Client-side stub - this should not be called on the client
    throw new Error("updateTenant is not available on the client side");
  }

  // Add future instance methods here that use this.client
}
